import {motion, AnimatePresence} from 'framer-motion';
import { useTheme } from '../contexts/ThemeContext';
import {JSX} from 'react'

export default function ThemeTransition():JSX.Element {
    const {transitionState} = useTheme();

    return (
        <AnimatePresence>
            {transitionState === 'fadeIn' && (
                <motion.div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: '#000000',
                        zIndex: 9999,
                        pointerEvents: 'none'
                    }}
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{
                        duration: 0.5, 
                        ease:'easeInOut',
                        repeat: 1,
                        repeatType: 'reverse',
                    }}
                >

                </motion.div>
            )}
            {transitionState === 'transitioning' && (
                <motion.div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: '#000000',
                        zIndex: 9999,
                        pointerEvents: 'none'
                    }}
                    initial={{opacity: 1}}
                >

                </motion.div>
            )}
            {transitionState === 'fadeOut' && (
                <motion.div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: '#000000',
                        zIndex: 9999,
                        pointerEvents: 'none'
                    }}
                    initial={{opacity: 1}}
                    animate={{opacity: 0}}
                    transition={{
                        duration: 0.5, 
                        ease:'easeInOut',
                        repeat: 1,
                        repeatType: 'reverse',
                    }}
                >

                </motion.div>
            )}
        </AnimatePresence>
    );
}